export default import.meta.ROLLUP_FILE_URL_9xROt_8JoI8P57AfOB76pA